import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import Loaderspinner from "../../components/Loader";
import ResourceForm from "../../components/Resources/ResourcesForm";
import { Link } from "react-router-dom";

import { resourceDetail, updateResource, showToast } from "../Utils/utils";

const EditResource = () => {
    const { id } = useParams();
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false);
    const [resource, setResource] = useState({});
    const [showSidebar, setShowSidebar] = useState(false);

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const fetchDetails = async () => {
        try {
            setLoading(true);

            const res = await resourceDetail(id);

            if (res?.status == 200) {
                setResource(res.data);
            } else {
                showToast("Resource not found");
                navigate("/resources");
            }

        } catch (error) {
            console.error(error);
            showToast("Failed to load resource");
            navigate("/resources");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDetails();
    }, [id]);

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("resource_id", id);
            formData.append("title", data.title);
            formData.append("sub_title", data.sub_title);
            formData.append("pro_tip", data.pro_tip);
            formData.append("category_id", data.category_id);
            formData.append("description", data.description);
            formData.append("file", data.file);

            const response = await updateResource({ formData });
            if (response.status == 200) {
                showToast(response.message || "Resource updated", "success");
                setTimeout(() => {
                    navigate("/resources");
                }, 800);
            } else {
                showToast(response?.data?.message || response?.data, "error")
            }

        } catch (error) {
            console.error(error);
            showToast(error.message || "Update failed");

        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}

            <div className="g-sidenav-show bg-gray-100 min-vh-100">
                <div id="wrapper">

                    <Leftbar
                        showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose}
                    />

                    <main className="main-content border-radius-lg">

                        <Topbar handleSidebar={handleSidebar} />
                        <div>
                            <div className="header header-bg pb-6">
                                <div className="container-fluid">
                                    <div className="header-body">
                                        <div className="row align-items-center py-4">
                                            <div className="col-lg-6 col-7">
                                                <nav
                                                    aria-label="breadcrumb"
                                                    className="d-none d-md-inline-block ml-md-4"
                                                >
                                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">
                                                                <i className="fas fa-home" />
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/resources"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Resources</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Edit Resource</span></Link>
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid mt-4">

                                <ResourceForm
                                    initialData={resource}
                                    onSubmit={onSubmit}
                                    loading={loading}
                                    buttonName="Update"
                                />

                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default EditResource;